import dayjs from "dayjs";

export function constructDocumentName(templateName: string): string {
    return `${templateName}_${dayjs().format("YYYYMMDD")}`
}
